// extracted by mini-css-extract-plugin
export default {"NavLink":"Nav_NavLink__n0kHJ","selected":"Nav_selected__8ygcw","div":"Nav_div__BUM3U"};